<template>
<el-container class="login">
    <!--<el-switch v-model="toggleParticles"

      inactive-color="#ff4949">

    ></el-switch>-->

    <el-card class="animated flipInY">
        <div slot="header" class="el-card-header">
            <!--<img src="../../assets/loginLogo.png" />-->
            MS CHAT
        </div>
        <el-form :rules="rules" :model="loginForm" ref="loginForm">
            <el-form-item prop="username" style="position:relative">
                <el-input type="text" v-model="loginForm.username"></el-input>
                <span class="svg-container">
                    <svg-icon icon-class="user" />
                </span>
            </el-form-item>
            <el-form-item prop="password">
                <el-input type="password" v-model="loginForm.password" @keyup.enter.native="onLogin"></el-input>
                <span class="svg-container">
                    <svg-icon icon-class="password" />
                </span>
            </el-form-item>
            <el-button type="primary" class="sendBtn" @click="onLogin" :loading="loading">登录</el-button>
        </el-form>
    </el-card>

    <el-dialog title="申诉" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
        <span class="failLogin">登录失败</span>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click.native="dialogVisible = false">确定</el-button>
        </div>
    </el-dialog>

</el-container>
</template>

<script>
// import { isValidUsername } from '@/utils/validate'
import ls from "@/common/localStorage"
import {
    mapActions
} from 'vuex'
export default {
    data() {
        // username 验证
        const validateUsername = (rule, value, callback) => {
            // if(!isValidUsername(value)) {
            // 	callback(new Error('请输入正确的用户名'))
            // } else {
            // 	callback()
            // }
            callback()
        }
        // pwd 验证
        const validatePwd = (rule, value, callback) => {
            if (value.length < 6) {
                callback(new Error('密码不能小于6位'))
            } else {
                callback()
            }
        }
        return {
            toggleParticles: false,
            rules: {
                username: [{
                        required: true,
                        message: '请输入账号',
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        trigger: 'blur',
                        validator: validateUsername
                    },
                    {
                        required: true,
                        trigger: 'change',
                        validator: validateUsername
                    }
                ],
                password: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        trigger: 'blur',
                        validator: validatePwd
                    },
                    {
                        required: true,
                        trigger: 'change',
                        validator: validatePwd
                    }
                ]
            },
            account: '账号',
            password: '密码',
            loginForm: {
                username: '',
                password: '',
                token: 'token'
            },
            loading: false,
            dialogVisible: false,
            addLoading: false
        }
    },
    created() {

    },
    methods: {
        onLogin() {
            console.log('登录')
            var that = this;
            var path = this.$route.params.Path;
            console.log(path)
            path ? '' : path = '/';
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    that.loading = true;
                    that.global.post('/user/webLogin', that.loginForm).then(res => {
                        console.log('登录结果', res)
                        if (res.data.token) {
                            ls.setItem("token", res.data.token);
                            ls.setItem("userInfo", res.data);
                            console.log(ls.getItem("userInfo"))
                            that.$store.commit('changeLogin', '100');
                            // that.initws()
                            that.$router.push({
                                path: path
                            });
                        } else {
                            that.loading = false;
                            that.$message({
                                message: "登录失败！",
                                type: "warning",
                                offset: 300
                            });
                        }
                    })
                }
            })
        },

        opendialog() { //代开模态框
            this.dialogVisible = true;
        }

    },
    mounted() {
        console.log(this.$route)
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    text-align: center;
}

.login {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: url(../../assets/loginBg.png) no-repeat center;
    overflow: hidden;
    background-size: cover;
    background-position: 50% 50%;

    .el-card {
        position: absolute;
        top: 50%;
        right: 25%;
        margin: -200px -160px 0;
        background: #395982;

        .el-card-header {
            text-align: center;
            padding-top: 19px;
            border-bottom: none;
            color: #fff;
            font-size: 30px;
            font-weight: bold;
            width: 300px;

            .loginTitle {
                margin: 0;
            }
        }

        .el-form {
            .el-input /deep/ input {
                text-indent: 12px;
                padding: 0 20px;
            }

            .svg-container {
                position: absolute;
                top: 0;
                left: 12px;
                color: #889aa4;
            }

            .sendBtn {
                width: 100%;
                margin-top: 20px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/login/index.vue